import { render, staticRenderFns } from "./ManagerDashboard.vue?vue&type=template&id=b4486c56&"
import script from "./ManagerDashboard.vue?vue&type=script&lang=js&"
export * from "./ManagerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports